import { H3 } from 'foundations-components/transitional/components/H3';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AchievementDescription = ({
  title,
  description,
  centered,
  hasMargin
}) => {
  return /*#__PURE__*/_jsxs(View, {
    marginInlineStart: hasMargin ? '1200' : '0',
    paddingBlockStart: "1000",
    textAlign: centered ? 'center' : 'left',
    children: [/*#__PURE__*/_jsx(H3, {
      typography: "heading-500",
      children: title
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      marginBlockStart: "400",
      children: description
    })]
  });
};
export default AchievementDescription;